import {
    REQUEST_CHECKOUT_PAY,
    SUCCESS_CHECKOUT_PAY,
    FAILURE_CHECKOUT_PAY,
    REQUEST_CHECKOUT_STATE,
    SUCCESS_CHECKOUT_STATE,
    FAILURE_CHECKOUT_STATE,
    REQUEST_CHECKOUT_DETAILS,
    SUCCESS_CHECKOUT_DETAILS,
    FAILURE_CHECKOUT_DETAILS
} from './constants';
import { PATH } from '../../constants/path';
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from '../../constants/httpMethod';

import { CALL_API } from '../../middlewares/api';
import gtm from '../../utils/gtmUtils';

export function submitCheckout(checkoutDatas, userInfo, partnerId, orderId) {
    const { token = undefined, deviceSessionId = undefined } = checkoutDatas;
    return {
        [CALL_API]: {
            endpoint: `/public/payment-solution/checkout/pay?email=${userInfo.email}${
                userInfo.userId ? `&userId=${userInfo.userId}` : ''
            }${userInfo.clickId ? `&clickId=${userInfo.clickId}` : ''}`,
            method: HTTP_METHOD_POST,
            body: { token, deviceSessionId, partnerId, ...userInfo, orderId },
            types: [REQUEST_CHECKOUT_PAY, SUCCESS_CHECKOUT_PAY, FAILURE_CHECKOUT_PAY],
            successCallback: response => {
                const { widgetLink } = response.payload;
                window.location.href = widgetLink;
            },
            errorCallback: response => {
                const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}&code=${response.status}`;
                window.location.href = errorUrl;
            },
            finallyCallback: () => {
                gtm.event('add_payment_info', { payment_method: 'Checkout' });
            }
        }
    };
}

export const fetchCheckoutState = orderId => {
    return {
        [CALL_API]: {
            endpoint: `/payment-solution/checkout/${orderId}/state`,
            types: [REQUEST_CHECKOUT_STATE, SUCCESS_CHECKOUT_STATE, FAILURE_CHECKOUT_STATE],
            method: HTTP_METHOD_GET
        }
    };
};

export const fetchCheckoutDetails = orderId => {
    return {
        [CALL_API]: {
            endpoint: `/payment-solution/checkout/${orderId}/details`,
            types: [REQUEST_CHECKOUT_DETAILS, SUCCESS_CHECKOUT_DETAILS, FAILURE_CHECKOUT_DETAILS],
            method: HTTP_METHOD_GET
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/checkout/actions.js